export default `
mutation {
  WxApplicationGenerateQrcode {
      success
      image
      error
      login_id
      created_at
      expiration_at
  }
}
`;